{
  "outputSpec": "mixed"
}
